<template>
  <div>
    <template v-if="singleValue">
      {{ singleValue }}
      <template v-if="showUnit && singleUnit">
        <span v-html="singleUnit[0]" />
        <div v-html="singleUnit[1]" />
      </template>
    </template>
    <md-menu
      v-if="!singleValue"
      :md-align-trigger="true"
      md-close-on-click
      class="target-value-inline-list">
      <md-button
        md-menu-trigger>
        <span v-html="displayValue" />
      </md-button>

      <md-menu-content class="md-menu-content-xxl">
        <md-table>
          <md-table-row>
            <md-table-head md-numeric>Valeur cible</md-table-head>
            <md-table-head>Fonction</md-table-head>
          </md-table-row>
          <md-table-row
            v-for="(targetInfos, targetValueLabel) in targetValues"
            :key="'function-'+targetValueLabel">
            <md-table-cell md-numeric>{{ getFormatedValue(targetInfos.value) }} <span v-html="targetInfos.unit" /></md-table-cell>
            <md-table-cell>{{ targetValueLabel }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-menu-content>
    </md-menu>
  </div>
</template>

<script>
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'

export default {
  name: 'TargetValuesInlineList',
  mixins: [ValuesDisplayMixin],
  mounted () {
  },
  props: {
    displayValue: {
      type: [String, Number],
      default: 'VC'
    },
    showUnit: {
      type: Boolean,
      default: true
    },
    targetValues: {
      type: [Object, Symbol],
      default: () => {
        return null
      }
    }
  },
  computed: {
    singleValue () {
      if (this.targetValues != null) {
        if (Object.keys(this.targetValues).length === 1) {
          return this.getRoundedValue(Object.entries(this.targetValues)[0][1].value)
        } else {
          return null
        }
      } else {
        return null
      }
    },
    singleUnit: function () {
      if (this.targetValues != null) {
        return this.splitUnit(Object.entries(this.targetValues)[0][1].unit)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-menu-content-xxl {
  min-width: 320px;
  z-index: 99;
}

.target-value-inline-list .md-button {
  width: 100%;
  min-width: 100%;
}

.target-value-inline-list .md-button >>> .md-ripple {
  justify-content: left;
}
</style>



// WEBPACK FOOTER //
// src/components/TargetValuesInlineList.vue